// modules
import { useNavigate } from "react-router-dom";

// components
import { Result } from "antd";
import Button from "components/atoms/Button/Button";

// hook
import { useAuthCheck } from "app/hooks/useAuthCheck";

const UnauthorisedAccessError = () => {
	const navigate = useNavigate();

	useAuthCheck();

	const handleClick = () => {
		navigate("/");
	};

	return (
		<Result
			status="403"
			title="403"
			subTitle="Sorry, you are not authorized to access this page."
			extra={
				<div className="w-full flex items-center justify-center">
					<Button background="violet" label={"Back Home"} onClick={handleClick}></Button>
				</div>
			}
		/>
	);
};

export default UnauthorisedAccessError;
